import { render, staticRenderFns } from "./VesselComparisonView.vue?vue&type=template&id=d9022b6c&scoped=true&"
import script from "./VesselComparisonView.vue?vue&type=script&lang=ts&"
export * from "./VesselComparisonView.vue?vue&type=script&lang=ts&"
import style0 from "./VesselComparisonView.vue?vue&type=style&index=0&id=d9022b6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9022b6c",
  null
  
)

export default component.exports